import { Component } from '@angular/core';

@Component({
  selector: 'app-open-femenino1-info-component',
  imports: [],
  templateUrl: './open-femenino1-info-component.html',
  styleUrl: './open-femenino1-info-component.scss'
})
export class OpenFemenino1InfoComponent {

}
